import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../Anchor';
import { setDetailPageUrl } from '../../../lib/common';
import { COUPON_DETAIL_URL_PATH } from '../../../constants/service/common/urlConstants';

const OpenCouponDetail = (props) => {
  const { text, couponId } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(text) && isNil(couponId)) {
    return '-';
  }

  return (
    <Anchor
      text={text}
      isUnderLine
      color="primary"
      href={setDetailPageUrl(COUPON_DETAIL_URL_PATH, couponId)}
      target="_blank"
    />
  );
};

export default OpenCouponDetail;
